export class SecretService {
    static $inject = ['MessagingHubService'];
    constructor(MessagingHubService) {
        this.MessagingHubService = MessagingHubService;
    }
    async get() {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            uri: '/secrets-keys',
            to: 'postmaster@builder.msging.net',
        });
    }
    async set(resource, type = 'application/vnd.lime.collection+json') {
        return await this.MessagingHubService.sendCommandSafe({
            method: 'set',
            to: 'postmaster@builder.msging.net',
            uri: '/secrets',
            type: type,
            resource: resource,
        });
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
SecretService.$inject = ['MessagingHubService'];
